// FaqArticle.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import media from '../style/media.js';
import { sanitize } from 'isomorphic-dompurify';

import DropDownIcon from '../../img/ic-dropdown-white-16-x-16.svg';
import Accordion, { Toggle, Collapse } from './Accordion.jsx';
import { color } from '../style/variables.js';

export const FaqArticle = ({
  id = '',
  title = null,
  body = null,
  activeId = '',
  onClick = () => null,
}) => {
  return (
    <StyledFaqArticle>
      <Accordion as={ToggleBox} activeKey={activeId} key={id}>
        <Toggle as={TitleBox} eventKey={id} onClick={onClick}>
          <Title isActive={id === activeId}>{title}</Title>
          <DropDown
            src={DropDownIcon.src || DropDownIcon}
            alt="DropDown"
            activeId={activeId}
            targetId={id}
          />
        </Toggle>
        <Collapse as={ContentBox} eventKey={id}>
          <RichContent
            dangerouslySetInnerHTML={{
              __html: sanitize(body),
            }}
          />
        </Collapse>
      </Accordion>
    </StyledFaqArticle>
  );
};

FaqArticle.propTypes = {
  activeId: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  onClick: PropTypes.func,
};

const StyledFaqArticle = styled.div`
  border-top: 1px solid rgb(100, 100, 100, 0.5);
  border-left: 1px solid rgb(100, 100, 100, 0.5);
  border-right: 1px solid rgb(100, 100, 100, 0.5);
  :last-child {
    border-bottom: 1px solid rgb(100, 100, 100, 0.5);
  }
  ${media.mobile`
    border-left: none;
    border-right: none;
  `};
  background-color: #232323;
`;

const ToggleBox = styled.div``;

const TitleBox = styled.div`
  padding: 24px 16px;
  display: flex;
  cursor: pointer;
`;

const Title = styled.div`
  flex-grow: 1;
  font-size: 22px;
  font-weight: 600;
  color: ${color.white};
  ${TitleBox}:hover & {
    opacity: 1;
  }
  ${({ isActive }) =>
    isActive
      ? css`
          border-left: 4px solid ${color.tealBlue};
          padding-left: 8px;
        `
      : ''}
`;

const DropDown = styled.img`
  height: 20px;
  width: 20px;
  transform: rotate(0deg);
  transition: all 0.1s linear;
  transform: ${({ activeId, targetId }) =>
    activeId === targetId ? 'rotate(180deg)' : ''};
`;

const ContentBox = styled.div`
  padding: 12px 18px 13px;
  font-size: 14px;
  line-height: 1.43;
`;

const RichContent = styled.div`
  width: 100%;
  height: 100%;
  img {
    display: block;
    margin: 0 auto;
    max-width: 80%;
  }
`;

export default FaqArticle;
